import React, { Component } from 'react';
import PropTypes from 'prop-types';
import iconShowPassword from '../../images/icons/icon_showpassword.png';
import iconHidePassword from '../../images/icons/icon_hidepassword.png';
import { withTranslation } from 'react-i18next';

const maxInputLength = '60';

class CustomInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, onChange, numbersOnly) {
    if(numbersOnly) {
      if(!/^[0-9]*$/.test(e.target.value)) {
        return null;
      }
    }
    onChange(e);
  }

  render() {
    const {
      field,
      form: { touched, errors },
      showError,
      showNote,
      isPassword,
      numbersOnly,
      disabled,
      t,
    } = this.props;

    const { showPassword } = this.state;
    const inputType = showPassword ? 'text' : 'password';

    const isError = touched[field.name] && errors[field.name];

    if(isPassword) {
      return (
        <>
          <div className="fe-form-password-container">
            <input
              maxLength={maxInputLength}
              className={isError ? 'fe-form-error-input' : ''}
              {...field}
              onBlur={this.props.onBlur || undefined}
              onKeyUp={this.props.onKeyUp || undefined}
              onChange={(e) => this.handleChange(e, field.onChange)}
              type={inputType}
            />
            <div
              className={`fe-form-password-eye ${showPassword ? 'active' : ''}`}
              onClick={() => this.setState((prevState) => ({
                showPassword: !prevState.showPassword,
              }))}
            >
              <img src={!showPassword ? iconHidePassword : iconShowPassword} alt=""/>
            </div>
          </div>
          { showError && isError && <span className="fe-form-error">{t(`error:${errors[field.name]}`)}</span> }
          { showNote !== '' && !isError && <span className="fe-form-note">{showNote}</span> }
        </>
      );
    }
    return (
      <>
        <input
          maxLength={maxInputLength}
          className={isError ? 'fe-form-error-input' : ''}
          disabled={disabled}
          {...field}
          onBlur={this.props.onBlur || undefined}
          onKeyUp={this.props.onKeyUp || undefined}
          onChange={(e) => this.handleChange(e, field.onChange, numbersOnly)}
        />
        { showError && isError && <span className="fe-form-error">{t(`error:${errors[field.name]}`)}</span> }
        { showNote !== '' && !isError && <span className="fe-form-note">{showNote}</span> }
      </>
    );
  }

}

CustomInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  showNote: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  numbersOnly: PropTypes.bool.isRequired,
  isPassword: PropTypes.bool,
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
};

CustomInput.defaultProps = {
  showError: true,
  showNote: '',
  numbersOnly: false,
  disabled: false,
};

export default withTranslation()(CustomInput);
